import { Link } from 'react-router-dom';
import Reveal from '@/pages/zz-review/components/Reveal';

const upcoming = [
  { name: '《一之門》', tag: 'HEB123・接枝宇宙生命樹', status: 'In Development' },
  { name: '《智人升級馨人》', tag: '生命角色進化', status: 'In Development' },
  { name: '《宇宙的漢摩拉比法典》', tag: '宇宙生命樹生機法則', status: 'Coming Soon' },
];

export default function CosmicLibrarySection() {
  return (
    <section id="library" className="w-full py-16 md:py-24 bg-background-50 scroll-mt-20">
      <div className="max-w-5xl mx-auto px-4 md:px-6">
        <Reveal>
          <div className="text-center mb-12 md:mb-16">
            <p className="text-xs tracking-[0.2em] uppercase text-foreground-400 mb-3">
              1001 Cosmic Letters
            </p>
            <h2
              className="text-2xl md:text-4xl text-foreground-900"
              style={{ fontFamily: 'var(--font-heading)' }}
            >
              1001 宇宙書信
            </h2>
            <div className="mt-5 flex flex-wrap items-center justify-center gap-2 md:gap-3">
              <span className="text-sm md:text-base text-foreground-700 bg-background-100 border border-background-200/70 rounded-full px-4 py-2 whitespace-nowrap">
                1001 宇宙書信
              </span>
              <i className="ri-arrow-right-line text-foreground-300" />
              <span
                className="text-base md:text-lg text-foreground-900 bg-primary-100 border border-primary-300/70 rounded-full px-5 py-2 whitespace-nowrap"
                style={{ fontFamily: 'var(--font-heading)' }}
              >
                1001 宇宙書架
              </span>
            </div>
            <p className="text-sm md:text-base text-foreground-500 mt-5 max-w-2xl mx-auto leading-relaxed">
              多年累積的生命、文明與宇宙探索紀錄，逐步整理、實踐並系統化，形成「1001 宇宙書架」。
            </p>
          </div>
        </Reveal>

        {/* 目前主要入口 */}
        <Reveal delay={60}>
          <div className="max-w-3xl mx-auto rounded-lg border border-primary-300/70 bg-background-100 px-6 md:px-8 py-7 md:py-8 mb-8">
            <p className="text-xs tracking-[0.2em] uppercase text-primary-700 mb-3 font-medium">
              目前主要的 5D 入口
            </p>
            <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
              <div>
                <h3
                  className="text-xl md:text-2xl text-foreground-900 mb-2"
                  style={{ fontFamily: 'var(--font-heading)' }}
                >
                  《1001旋轉門 Revolving Gate》
                </h3>
                <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
                  《1001旋轉門》是「1001 宇宙書架」率先完成、目前進入出版募資階段的生命實踐著作。其定位不是 AUM1001 Matrix 的全部，而是：讓目前生活在
                  &lt;5D（欲界天）世界中的人，從自己的位置開始，整合 1D–5D，回到中軸，抵達 5D 本心／鑽石心錨的第一個實踐入口，可以帶著肉身揚升 5D。
                </p>
              </div>
              <Link
                to="/revolving-gate"
                className="shrink-0 whitespace-nowrap px-6 py-3 rounded-md bg-primary-500 text-background-50 text-sm hover:bg-primary-600 transition-colors cursor-pointer text-center"
              >
                進入《1001旋轉門》
              </Link>
            </div>
          </div>
        </Reveal>

        {/* 後續書籍／入口 */}
        <Reveal delay={100}>
          <p className="text-center text-sm text-foreground-500 mb-6">後續書籍／入口</p>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            {upcoming.map((book) => (
              <div
                key={book.name}
                className="rounded-lg border border-background-200/70 bg-background-100 px-5 py-6"
              >
                <p
                  className="text-base md:text-lg text-foreground-900 font-medium mb-1"
                  style={{ fontFamily: 'var(--font-heading)' }}
                >
                  {book.name}
                </p>
                <p className="text-sm text-foreground-500 mb-4">{book.tag}</p>
                <span className="inline-flex items-center gap-1.5 text-xs text-foreground-400 border border-background-200/70 rounded-full px-3 py-1 whitespace-nowrap">
                  <i className="ri-loader-4-line" />
                  {book.status}
                </span>
              </div>
            ))}
          </div>
        </Reveal>

        <Reveal delay={140}>
          <p className="text-center text-xs text-foreground-400 mt-8">
            尚未正式公開完成者標示 In Development / Coming Soon。
          </p>
        </Reveal>
      </div>
    </section>
  );
}